module.exports = __webpack_public_path__ + "img/grain-bg.ddda70ca.png";